import { render, staticRenderFns } from "./PlanesSaep.vue?vue&type=template&id=5a908b6c&scoped=true&"
import script from "./PlanesSaep.vue?vue&type=script&lang=js&"
export * from "./PlanesSaep.vue?vue&type=script&lang=js&"
import style0 from "./PlanesSaep.vue?vue&type=style&index=0&id=5a908b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a908b6c",
  null
  
)

export default component.exports